import type { SectionProductDetail } from '@space-shell/common/services/sections'
import { SectionProductDetailStatus } from '@space-shell/common/services/sections'

export const isSectionEnabledToShow = (product?: SectionProductDetail) => {
  if (!product?.status) return true

  const isProductActive = product.status === SectionProductDetailStatus.ACTIVE

  return isProductActive && (product.showForSale || product.purchased)
}
